var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoogleMaps(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "iconfinder_logo_brand_brands_logos_maps_google_2993681") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-5.70320917%",
    y1: "27.0500979%",
    x2: "99.7328837%",
    y2: "76.2157521%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0.2,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0,
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    transform: "translate(-310.000000, -187.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "iconfinder_logo_brand_brands_logos_maps_google_2993681",
    transform: "translate(310.000000, 187.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.3636364,2 L15.9545455,2 L0,17.9545455 L0,18.3636364 C0,19.2661132 0.733886755,20 1.63636364,20 L2.1758922,20 L18,3.96725183 L18,3.63636364 C18,2.73388675 17.2661132,2 16.3636364,2 Z",
    id: "Path",
    fill: "#FDDC49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.64102564,2 C0.7359776,2 0,2.7359776 0,3.64102564 L0,18 L16,2 L1.64102564,2 Z",
    id: "Path",
    fill: "#56A959"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#5796FF",
    points: "2 20 16 20 8.95418175 13"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#CCCCCC",
    points: "11 11.0458346 18 18 18 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,13.0604198 L15.9499613,20 L16.3599691,20 C17.2644685,20 18,19.2655672 18,18.3624188 L18,17.9530235 L11.0365752,11 L9,13.0604198 Z",
    id: "Path",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3636364,2 L1.63636364,2 C0.733886755,2 0,2.79730907 0,3.77777778 L0,4 C0,3.01953129 0.733886755,2.22222222 1.63636364,2.22222222 L16.3636364,2.22222222 C17.2661132,2.22222222 18,3.01953129 18,4 L18,3.77777778 C18,2.79730907 17.2661132,2 16.3636364,2 Z",
    id: "Path",
    fill: "#FFFFFF",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3636364,19.7777778 L1.63636364,19.7777778 C0.733886755,19.7777778 0,18.9804687 0,18 L0,18.2222222 C0,19.2026909 0.733886755,20 1.63636364,20 L16.3636364,20 C17.2661132,20 18,19.2026909 18,18.2222222 L18,18 C18,18.9804687 17.2661132,19.7777778 16.3636364,19.7777778 Z",
    id: "Path",
    fill: "#000000",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,0 C12.2428385,0 10,2.26644733 10,5.05263158 C10,5.2495888 10.0134277,5.44284539 10.0345866,5.62664472 C10.2083333,7.42228615 11.1584473,8.90131579 12.1647135,10.4666941 C13.1538899,12.0057565 14.1764322,13.5970395 14.5918782,15.662829 C14.6309407,15.8589638 14.8018392,16 15,16 C15.1981608,16 15.3690593,15.8589638 15.4081218,15.662829 C15.8235678,13.5970395 16.84611,12.0057566 17.8352865,10.4666941 C18.8415527,8.90131579 19.7916667,7.42228615 19.9645996,5.63363486 C19.9865723,5.44284539 20,5.2495888 20,5.05263158 C20,2.26644733 17.7571615,0 15,0 Z",
    id: "Path",
    fill: "#E53935"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9991967,0.229656151 C17.3124721,0.229656151 19.2813428,1.803969 20,4 C19.3807816,1.68975769 17.3744626,0 14.9991967,0 C12.6239308,0 10.6192184,1.68380702 10,3.99404933 C10.7186572,1.79801833 12.6859214,0.229656151 14.9991967,0.229656151 Z",
    id: "Path",
    fill: "#FFFFFF",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9645996,5.48325587 C19.7916667,7.26173568 18.8415527,8.73235456 17.8352865,10.288831 C16.8461101,11.8191414 15.8235678,13.4013752 15.4081218,15.4554172 C15.3690593,15.6504367 15.1981608,15.7906709 15,15.7906709 C14.8018392,15.7906709 14.6309407,15.6504367 14.5918782,15.4554172 C14.1764322,13.4013752 13.15389,11.8191415 12.1647135,10.288831 C11.1584473,8.73235456 10.2083333,7.26173568 10.0345866,5.47630547 C10.0169372,5.32395926 10.0093588,5.16266949 10.0057475,5.00056209 C10.0048828,5.03894258 10,5.07630088 10,5.11488568 C10,5.31072287 10.0134277,5.50288048 10.0345866,5.68563459 C10.2083333,7.4710648 11.1584473,8.94168369 12.1647135,10.4981602 C13.1538899,12.0284705 14.1764322,13.6107043 14.5918782,15.6647463 C14.6309407,15.8597658 14.8018392,16 15,16 C15.1981608,16 15.3690593,15.8597658 15.4081218,15.6647463 C15.8235678,13.6107043 16.84611,12.0284706 17.8352865,10.4981602 C18.8415527,8.94168369 19.7916667,7.4710648 19.9645996,5.69258499 C19.9865723,5.50288048 20,5.31072287 20,5.11488568 C20,5.07609641 19.9950663,5.0385848 19.9942017,5 C19.9906412,5.16282289 19.982961,5.32457251 19.9645996,5.48325587 Z",
    id: "Path",
    fill: "#000000",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#B71C1C",
    cx: 15.5,
    cy: 5.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#000000",
    opacity: 0.1,
    cx: 15.5,
    cy: 5.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.5,9 C3.12141925,9 2,7.87858075 2,6.5 C2,5.12141925 3.12141925,4 4.5,4 C5.04646808,4 5.56567383,4.17333983 6.00187175,4.50089517 L5.5013835,5.16739908 C5.21044925,4.94889325 4.86417642,4.83333333 4.5,4.83333333 C3.58081058,4.83333333 2.83333333,5.58081058 2.83333333,6.5 C2.83333333,7.41918942 3.58081058,8.16666667 4.5,8.16666667 C5.2751465,8.16666667 5.92862958,7.634847 6.1137695,6.91666667 L4.91666667,6.91666667 L4.91666667,6.08333333 L7,6.08333333 L7,6.5 C7,7.87858075 5.87858075,9 4.5,9 Z",
    id: "Path",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,5 C20,2.2428385 17.7571615,0 15,0 C13.5241191,0 12.199707,0.646464 11.2837219,1.66666667 L1.66666667,1.66666667 C0.74747725,1.66666667 0,2.41414392 0,3.33333333 L0,18.3333333 C0,19.2525228 0.74747725,20 1.66666667,20 L16.6666667,20 C17.5858561,20 18.3333333,19.2525228 18.3333333,18.3333333 L18.3333333,9.58084108 C19.1374715,8.30724083 19.8207601,7.04696658 19.9645996,5.57495117 C19.9865722,5.38614908 20,5.19490558 20,5 Z",
    id: "Path",
    fill: "url(#linearGradient-1)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleMaps);
export default __webpack_public_path__ + "static/media/google_maps.5f0399e54695f9b9552e34f4c8fdda7b.svg";
export { ForwardRef as ReactComponent };